import { useState } from "react";
import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import { Button } from "src/components/Button/Button.tsx";
import { Input } from "src/components/Input/Input.tsx";
import { useResourceFormTranslation } from "src/components/Form/hooks/useResourceFormTranslation.ts";

type Props = {
  title: string;
  description?: string;
  required?: boolean;
  confirmLabel: string;
  isPending: boolean;
  onSubmit: (reason: string) => void;
  onClose: () => void;
};

// Подтверждение действия с причиной (отмена, отклонение, закрытие остатка).
export const ReasonDialog = ({
  title,
  description,
  required = true,
  confirmLabel,
  isPending,
  onSubmit,
  onClose,
}: Props) => {
  const { t } = useResourceFormTranslation();
  const [reason, setReason] = useState("");

  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>{title}</ModalV3.Title>
          </ModalV3.Header>
          <ModalV3.Body style={{ width: 460 }}>
            {description && <p style={{ marginTop: 0 }}>{description}</p>}
            <Input
              label={t("dialog.reason")}
              value={reason}
              maxLength={255}
              autoFocus
              onChange={(event) => setReason(event.target.value)}
            />
          </ModalV3.Body>
          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <Button variant={"outlined"} onClick={onClose}>
                {t("dialog.cancel")}
              </Button>
              <Button
                variant={"filled"}
                disabled={isPending || (required && reason.trim() === "")}
                onClick={() => onSubmit(reason.trim())}
              >
                {confirmLabel}
              </Button>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
};
